// Flag can submit
var formCanSubmit = true;

// Function to prevent submitting
window.beforeSubmit = function (e) {
    if (! formCanSubmit) {
        e.preventDefault();

        return;
    }
}

// Enable submit button -- dispatching in UploadFile.vue
window.addEventListener('enable-form-submit', function () {
    formCanSubmit = true;
    document.querySelector('button[type="submit"]').removeAttribute('disabled');
});

// Disable submit button -- dispatching in UploadFile.vue
window.addEventListener('disable-form-submit', function () {
    formCanSubmit = false;
    document.querySelector('button[type="submit"]').setAttribute('disabled', 'disabled');
});